import { MultiSelect } from '@mantine/core';

/**
 * 5½ / C3 — KATILIMCI SEÇİCİ, TEK DESEN (Kapsam §16.10/25).
 *
 * Detayın soluk satırı (Y2/K3) ile yeni kayıt formu aynı bileşeni çağırır —
 * *"tek desen, iki çağıran"*. Toplu seçim (salonda liste tek seferde işlenir);
 * taraf (ana firma / yüklenici) burada SORULMAZ — istihdamdan otomatik (T2),
 * her iki çağıranda aynı yerden (`yukleniciPersonIds`).
 *
 * ⚠️ Portal ZORUNLU: `Bolum`/`Card` açılır listeyi kırpar (4½ dersi).
 */
export function KatilimciSecici({
  adaylar,
  value,
  onChange,
  testId,
  label,
}: {
  adaylar: readonly { id: string; adSoyad: string }[];
  value: string[];
  onChange: (v: string[]) => void;
  testId: string;
  /** Formda etiketli, soluk satırda etiketsiz (aria-label yeter). */
  label?: string;
}): React.JSX.Element {
  return (
    <MultiSelect
      size={label ? 'sm' : 'xs'}
      searchable
      clearable
      label={label}
      placeholder="Katılımcı ekle (birden çok seçilebilir)"
      aria-label={label ?? 'Katılımcı ekle'}
      data-testid={testId}
      comboboxProps={{ withinPortal: true }}
      data={adaylar.map((p) => ({ value: p.id, label: p.adSoyad }))}
      value={value}
      onChange={onChange}
    />
  );
}
